import { isPlainObject } from "../../../../util/isPlainObject";
import { SearchFieldKey } from "./SearchFieldKey";
import { SearchTypeKey } from "./SearchTypeKey";

export interface SearchToken {
  searchString: string;
  type: SearchTypeKey;
  field: SearchFieldKey;
}

export function isSearchToken(x: unknown): x is SearchToken {
  if (!isPlainObject(x)) return false;
  const { searchString, type, field } = x;
  if (typeof searchString !== "string") return false;
  if (!Object.values(SearchTypeKey).includes(type as SearchTypeKey))
    return false;
  if (!Object.values(SearchFieldKey).includes(field as SearchFieldKey))
    return false;
  return true;
}

export function isNonEmptySearchToken(x: unknown): x is SearchToken {
  if (!isSearchToken(x)) return false;
  const { searchString } = x;
  // Require a non-empty searchString
  if (searchString.trim().length === 0) return false;
  return true;
}
